import { Grid, Theme, Typography, withStyles, Button } from '@material-ui/core'
import { useEffect, useState } from 'react'
import LoadingContainer from '../../../components/LoadingContainer/LoadingContainer'
import i18n from '../../../translations/i18n'
import { MuiClasses } from '../../../types'
import ApplicationsApi from '../../../services/applications'
import ShowingsApi from '../../../services/showings'
import { ApplicationStatus } from '../../../types/applications'
// import NextStepButton from '../NextStepButton'
//import Suggest2 from '../../InstantRentApplication/Steps/Suggest'
import Suggest from '../../Apartment/Stepper/Steps/Suggest'
import ApartmentInfoSuggest from '../ApartmentInfoSuggest'
import {
    ReduxFormField
} from '../../../components/FormInput/ReduxWrappers'
import {
    lessThanAvailableUntil,
    required,
} from '../../../utils/validation/forms'
import ReduxPicker from '../../../components/FormInput/ReduxWrappers/ReduxPicker'

const styles = ({ breakpoints, typography }: Theme) => ({
    // customSuggestTextStyles: {
    //     fontSize: '1.125rem',
    //     fontWeight: typography.fontWeightLight,
    //     fontFamily: 'CircularRegular',
    //     fontStyle: 'normal',
    //     maxWidth: '97%',
    //     margin: '0.2rem auto',
    //     marginLeft: '1rem',
    //     lineHeight: '1.625rem',
    //     textAlign: 'left !important',
    //     [breakpoints.down('sm')]: {
    //         maxWidth: '100%',
    //         lineHeight: '1.1',
    //         fontSize: typography.pxToRem(28)
    //     }
    // },
    blackText: {
        color: '#000000'
    },
    infoText: {
        fontSize: typography.pxToRem(18)
    },
    guaranteeText: {
        marginTop: '37px',
        marginBottom: '39px',
        [breakpoints.down('sm')]: {
            marginTop: '45px',
            marginBottom: '56px',
            fontSize: '1.6rem'
        }
    },
    infoContainer: {
        display: 'flex',
        fontWeight: typography.fontWeightLight,
        marginBottom: '41px'
    },
    tickIcon: {
        marginRight: '13px',
        marginTop: '10px'
    },
    primaryBtn: {
        height: '82px',
        width: '100%',
        textTransform: 'capitalize' as const,
        fontWeight: typography.fontWeightBold,
        fontSize: '24px',
        marginTop: '60px',
        '@media (min-width: 780px)': {
            height: '65px'
        }
    },
    datePickerParent: {
        display: 'flex',
        alignItems: 'center', // Centers content vertically
        justifyContent: 'center', // Centers content horizontally
        height: '100%', // Adjust as needed
        width: '100%',
        flexDirection: 'row', // Default to column direction
        // Media query for screens smaller than or equal to 'sm'
        '@media (max-width:660px)': {
            flexDirection: 'column',
            marginTop: '0.7rem' // Change to row direction for smaller screens
        },
    },
    buttonContainer: {
        minWidth: '100%',
        justifyContent: 'center' as const,
        margin: '2.2rem 0 2rem 0 !important',
        '@media (min-width: 780px)': {
            margin: '2.2rem 0 2rem 0'
        },
        '@media (max-width:660px)': {
            marginTop: '1rem !important', // Change to row direction for smaller screens
        },
        [breakpoints.down('sm')]: {
            marginTop: '0rem',
        }
    },
    fullWidth93: {
        width: '100%',
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    horizontalPadding4: {
        paddingLeft: '1.53rem',
        paddingRight: '1.53rem'
    },
    containerStyle: {
        marginTop: '3.5rem !important',
        '@media (max-width: 960px)': {
            marginTop: '1rem !important',
        },
        '@media (min-width: 960px) and (max-width: 1190px)': {
            marginLeft: '2rem !important',
            marginRight: '2rem !important'
        }
    },
    headerStyle: {
        color: '#000',
        textAlign: 'center',
        fontFamily: 'CircularRegular',
        fontSize: '2rem',
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: '3.25rem', // 162.5%
        marginBottom: '2rem',
    },
    pickerStyles: {
        maxWidth: '15rem',
        paddingLeft: '5px',
        paddingTop: '6px',
        paddingBottom: '6px',
    },
    datePickerText: {
        marginTop: '6px',
        textAlign: 'right',
        paddingRight: '10px',
        '@media (max-width:660px)': {
            textAlign: 'center',
            marginTop: '0px'
        },
    },
    suggestContainer: {
        marginLeft: 'auto', marginRight: 'auto', marginBottom: '1rem',
        '@media (max-width:660px)': {
            marginBottom: '0rem',
        }
    },
    apartmentInfoSuggestContainer: {
        marginLeft: 'auto',
        marginRight: 'auto',
        marginBottom: '1rem'
    }
})

type InstantRentPromptProps = {
    classes: MuiClasses
    beforeLogin?: boolean
    applicationCode: string
    t: i18n.TFunction
    navigateTo: (arg: number) => void
    readyForMoveDate?: any
}

const AcceptOrDecline = ({
    classes,
    beforeLogin,
    applicationCode,
    t,
    navigateTo,
    readyForMoveDate
}: InstantRentPromptProps) => {
    const [isApartment, setApartment] = useState(null) as any
    const [isLoading, setLoading] = useState(false)
    const [errorMessage, setErrorMessage] = useState('');
    const getApartmentByApplicationCodeHandler = async () => {
        setLoading(true);

        // Use promises and async/await for better code readability and error handling
        try {
            //const application = await ApplicationsApi.getApplicationByCode(applicationCode);
            const data = await ShowingsApi.getForRentapp(applicationCode);
            //console.log(data);

            const apartment = data.apartment
            setApartment(apartment);
            localStorage.setItem('apartment', JSON.stringify(apartment));
            setLoading(false);

            if (apartment?.status === 'rented') {
                showRentedAlertAndRedirect();
            }

            // Handle locked apartment for other users (uncomment if needed)
            // if (
            //   apartment.status === 'rentContractWanted' &&
            //   apartment.applicationIds?.contractWantedId &&
            //   !localStorage.getItem('application')
            // ) {

            //   // TODO: Implement the logic to setApartmentLocked
            //   // Example: setApartmentLocked(5);
            // }
        } catch (error) {
            //console.error(error);

            // Handle errors, e.g., show an error message or redirect
            showGeneralAlertAndRedirect();
            setLoading(false);
        }
    };

    const showRentedAlertAndRedirect = () => {
        alert(t('instantRent.apartmentRented'))
        setTimeout(() => {
            window.location.href = 'https://fiksuvuokraus.fi/'
        }, 0)
    }

    const showGeneralAlertAndRedirect = () => {
        alert(t('instantRent.generalError'))
        setTimeout(() => {
            window.location.href = 'https://fiksuvuokraus.fi/'
        }, 0)
    }

    // const handleFormEvent = () => {
    //     if (localStorage.getItem('application')) {
    //         navigateTo(2)
    //         return
    //     }

    //     // setLoading(true)
    //     // //TÄMÄ PITÄÄ TSEKKAA
    //     // Api.startInstantRent({
    //     //     apartmentsCode,
    //     //     language: localStorage.getItem('language') || 'en'
    //     // })
    //     //     .then((application) => {
    //     //         setLoading(false)
    //     //         localStorage.setItem('application', JSON.stringify(application))
    //     //         navigateTo(2)
    //     //     })
    //     //     .catch((error) => {
    //     //         setLoading(false)
    //     //    })
    // }

    const goForward = () => {
        if (readyForMoveDate) {
            localStorage.setItem('readyForMoveDate', readyForMoveDate);
            navigateTo(2)
        } else {
            setErrorMessage(t('afterShowing.pickTenancyStartDate'));
        }
    }

    const declineApartment = async () => {
        navigateTo(0)
        try {
            await ApplicationsApi.updateApplicationStatusByCode(applicationCode, {
                status: ApplicationStatus.notInterested
            });
            //console.log(response);

        } catch (error) {
            //console.error('Error updating application status:', error);
        }
    }

    useEffect(() => {
        getApartmentByApplicationCodeHandler()
        setApartment(JSON.parse(localStorage.getItem('apartment') || '{}'))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            {isLoading ? (
                <LoadingContainer />
            ) : (
                <Grid
                    className={`${classes.responsiveWidth} ${classes.containerStyle}`}
                    style={{ maxWidth: '1131px', margin: 'auto' }}
                >
                    <div className={classes.headerStyle}>
                        {t('afterShowing.acceptOrDeclineHeader')}
                    </div>
                    {isApartment && (
                        <div
                            className={`${classes.apartmentInfoSuggestContainer}`}>
                            <ApartmentInfoSuggest t={t} apartment={isApartment} />
                        </div>
                    )}
                    <div
                        className={`${classes.suggestContainer}`}>
                        <Suggest
                            content={t('afterShowing.acceptOrDeclineDisclaimer')}
                            containerMaxWidth='100%'
                            contentMaxWidth='100%'
                            bigPaddingOnLargeScreens={true}
                        />
                    </div>
                    <div style={{ marginLeft: 'auto', marginRight: 'auto' }}>
                        <Grid
                            container
                            justify="center" // Center the items in the container
                            alignItems="center"
                            style={{
                                width: '100%',
                                marginLeft: 'auto',
                                marginRight: 'auto'
                            }}
                            className={`${classes.datePickerParent}`}
                        >
                            {/* Typography Grid item */}
                            <Grid item xs={6}> {/* Adjust the size and spacing as needed */}
                                <Typography
                                    variant='body2'
                                    className={`${classes.labelText} ${classes.datePickerText}`}
                                >
                                    {t('afterShowing.startDateForLeasing')}:
                                </Typography>
                            </Grid>

                            {/* ReduxFormField Grid item */}
                            <Grid item xs={12} sm={6}> {/* Adjust the size as needed */}
                                <ReduxFormField
                                    fullWidth
                                    name='readyForMoveDate'
                                    validate={[required, lessThanAvailableUntil]}
                                    component={ReduxPicker}
                                    //label={t('afterShowing.pickTenancyStartDate')}
                                    className={`${classes.inlineDatePicker} ${classes.pickerStyles}`}
                                    style={{
                                        backgroundColor: '#E7ECEF',
                                        fontSize: '20px',
                                        //borderRadius: '8px',
                                    }}
                                    InputProps={{
                                        disableUnderline: true, className: classes.customInput
                                    }}
                                    InputLabelProps={{ className: classes.customInputLabel }}
                                />
                            </Grid>
                        </Grid>
                        {errorMessage && (
                            <Grid container justifyContent="center">
                                <Grid item xs={12}>
                                    <Typography
                                        style={{ color: 'red', marginTop: '10px' }}
                                        variant='body1'
                                        align='center'
                                    >
                                        {errorMessage}
                                    </Typography>
                                </Grid>
                            </Grid>
                        )}
                    </div>
                    <div className={classes.fullWidth93}>
                        <Grid container className={classes.buttonContainer}>
                            <Grid item md={12} xs={12}>
                                {/* <NextStepButton
                  type='button'
                  customLabel={t('instantRent.buttonLabels.startRenting')}
                  customStyles={classes.primaryBtn}
                  classes={classes}
                  beforeLogin={beforeLogin}
                /> */}
                                <Button
                                    fullWidth
                                    variant='contained'
                                    color='primary'
                                    className={`${classes.responsiveButtonAfterShowing}`}
                                    onClick={goForward}
                                >
                                    <Grid container justify='center' alignItems='center'>
                                        <Grid item>{t('afterShowing.acceptApartment')}</Grid>
                                    </Grid>
                                </Button>
                                <Button
                                    fullWidth
                                    variant="outlined"
                                    className={`${classes.responsiveButtonAfterShowing}`}
                                    onClick={declineApartment}

                                >
                                    <Grid container justify='center' alignItems='center'>
                                        <Grid item>{t('afterShowing.declineApartment')}</Grid>
                                    </Grid>
                                </Button>
                                {/* {isApartmentLocked && (
                  <Typography
                    align='center'
                    variant='body1'
                    className={`${classes.blackText} ${classes.mdText}`}
                    style={{
                      color: 'red'
                    }}
                  >
                    {t('instantRent.placeholders.aparmentBookedNotice', {
                      counter: isApartmentLocked
                    })}
                  </Typography>
                )} */}
                            </Grid>
                        </Grid>
                    </div>
                </Grid>
            )}
        </>
    )
}

export default withStyles(styles)(AcceptOrDecline)
